/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsMachineLicenseListItem,
    ControlcenterMelcoModelsMachineLicenseListItemFromJSON,
    ControlcenterMelcoModelsMachineLicenseListItemFromJSONTyped,
    ControlcenterMelcoModelsMachineLicenseListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsMachineLicenseListItem>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem
     */
    list: Array<ControlcenterMelcoModelsMachineLicenseListItem>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItemFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem {
    return ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsMachineLicenseListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItemToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsMachineLicenseListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsMachineLicenseListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


